import { render, staticRenderFns } from "./PriceListForm.vue?vue&type=template&id=7faceafc&scoped=true&"
import script from "./PriceListForm.vue?vue&type=script&lang=js&"
export * from "./PriceListForm.vue?vue&type=script&lang=js&"
import style0 from "./PriceListForm.vue?vue&type=style&index=0&id=7faceafc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faceafc",
  null
  
)

export default component.exports